<ng-container [formGroup]="formGroup">
  <visana-lib-form-field
    *ngIf="formGroup.get('email') as emailFormGroup"
    [error]="validatorService.getEmailErrorMessage(emailFormGroup, validateForm)"
    inputId="email"
    label="{{ 'COMMON.EMAIL' | translate }}"
  >
    <input
      id="email"
      data-cy="input-email"
      formControlName="email"
      placeholder="{{ 'COMMON.EMAIL' | translate }}"
      type="email"
    />
  </visana-lib-form-field>
  <visana-lib-form-field
    *ngIf="formGroup.get('phone') as phoneFormGroup"
    [error]="validatorService.getErrorMessage(phoneFormGroup, validateForm)"
    inputId="phone"
    label="{{ 'COMMON.PHONE_NR' | translate }}"
  >
    <input
      id="phone"
      data-cy="input-phone"
      formControlName="phone"
      placeholder="{{ 'COMMON.PHONE_NR' | translate }}"
      type="tel"
    />
  </visana-lib-form-field>
  <div class="horizontal">
    <visana-lib-form-field
      [error]="validatorService.getErrorMessage(formGroup.get('street'), validateForm)"
      class="grow"
      inputId="street"
      label="{{ 'COMMON.STREET' | translate }}"
    >
      <input
        data-cy="input-street"
        formControlName="street"
        id="street"
        placeholder="{{ 'COMMON.STREET' | translate }}"
      />
    </visana-lib-form-field>
    <visana-lib-form-field
      [error]="validatorService.getErrorMessage(formGroup.get('houseNumber'), validateForm)"
      class="street-number"
      inputId="houseNumber"
      label="{{ 'COMMON.NUMBER' | translate }}"
    >
      <input
        data-cy="input-house-number"
        formControlName="houseNumber"
        id="houseNumber"
        placeholder="{{ 'COMMON.NUMBER' | translate }}"
      />
    </visana-lib-form-field>
  </div>

  <ng-container *ngIf="showZipCodeComponent$ | async; else noChangeNeeded">
    <ssc-zip-code-autocomplete
      [formControl]="address"
      [saleOfferBegin]="saleOfferBegin.value"
      [validateForm]="validateForm"
    ></ssc-zip-code-autocomplete>
  </ng-container>
  <ng-template #noChangeNeeded>
    <div class="horizontal">
      <visana-lib-form-field
        [disabled]="true"
        class="zip"
        inputId="zipCode"
        label="{{ 'COMMON.ZIP_CODE' | translate }}"
      >
        <input
          formControlName="zipCode"
          id="zipCode"
          placeholder="{{ 'COMMON.ZIP_CODE' | translate }}"
          type="number"
          data-cy="input-zip-code"
        />
      </visana-lib-form-field>
      <visana-lib-form-field [disabled]="true" class="grow" inputId="city" label="{{ 'COMMON.CITY' | translate }}">
        <input formControlName="city" id="city" placeholder="{{ 'COMMON.CITY' | translate }}" data-cy="input-city" />
      </visana-lib-form-field>
    </div>
  </ng-template>
</ng-container>
